import { z } from 'zod';

export const JsonSchema = z.unknown();
